import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pagination-container w-100 mt-30" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow icon-reverse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-arrow" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.paginator.last_page > 3)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "pagination-btn",
          disabled: _ctx.paginator.current_page === 1,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
        }, _hoisted_4, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationRange, (pageNumber) => {
      return (_openBlock(), _createElementBlock("button", {
        key: pageNumber,
        class: _normalizeClass(["pagination-btn", { 'active': _ctx.paginator.current_page === pageNumber }]),
        onClick: ($event: any) => (_ctx.goToPage(pageNumber))
      }, _toDisplayString(pageNumber), 11, _hoisted_5))
    }), 128)),
    (_ctx.paginator.last_page > 3)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "pagination-btn",
          disabled: _ctx.paginator.current_page === _ctx.paginator.last_page,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
        }, _hoisted_8, 8, _hoisted_6))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _ctx.paginator.last_page > 1]
  ])
}